<template>
  <div class="list row">    
    <div v-if="message" class="col-md-12 alert alert-danger">
      {{message}}
    </div>
   
    <div class="col-md-12 hgap"></div>

    <div v-if="successful" class="col-md-12">
      <h4><font-awesome-icon icon="table" /> All Awards</h4>
      <table class="gridview">
        <tr>
            <th>Network ID</th><th>Name</th><th>Award Date</th><th>Award</th><th>Payment Status</th><th>Payment Date</th>
        </tr>
        <tr class="table" :class="{ active: index== currentIndex }" v-for="(memberAward, index) in memberAwards" :key="memberAward.id" @click="toggleClass(this,'selected')">
            <td>{{ memberAward.network_member_id }}</td><td>{{ memberAward.surname }},&nbsp; {{ memberAward.first_name }}</td><td>{{ memberAward.award_date | moment("DD/MM/YYYY") }}</td>
            <td>{{ memberAward.name }}</td><td v-if="memberAward.paid">Paid</td><td v-else>Not paid</td>
            <td v-if="!memberAward.payment_date"><a class="m-3 btn btn-sm btn-warning"><font-awesome-icon icon="edit" /> Pay </a></td><td v-else>{{ memberAward.payment_date | moment("DD/MM/YYYY") }}</td>
        </tr>
      </table>
      <div class="col-md-12 hgap"></div>
      <div v-if="loading" class="justify-content-center">
        <font-awesome-icon icon="spinner" /> <span>Loading...please wait</span>
      </div>
      <table class="table table-borderless">
        <tr>
          <td>
            <div class="d-flex justify-content-center">
              Items per Page:
              <select v-model="pageSize" @change="handlePageSizeChange($event)">
                <option v-for="size in pageSizes" :key="size" :value="size">
                  {{ size }}
                </option>
              </select>
            </div>
          </td>
          <td>
            <div class="d-flex justify-content-end">
              <b-pagination v-model="page" :total-rows="count" :per-page="pageSize" prev-text="Prev" next-text="Next" @change="handlePageChange"></b-pagination>
            </div>
          </td>
        </tr>
      </table>
    </div>
  </div>
</template>

<script>
import MemberAwardService from "../services/member-award.service";

export default {
  name: "bonus-list",
  data() {
    return {
      message: '',
      successful: false,
      memberAwards: [],
      currentIndex: 0,
      page: 1,
      count: 0,
      pageSize: 100,
      pageSizes: [25, 50, 75, 100],
      totalPages: 0,
      loading: false
    };
  },
  methods: {
    retrieveMemberAwards() {
      this.loading = true;
      if (this.page) {
        this.page = this.page - 1;
      }
      MemberAwardService.getTotalMemberAwards()
        .then(response => {
          this.count = response.data;
          //console.log(response.data);
        })
        .catch(e => {
          console.log(e);
        });   
      MemberAwardService.getAll(this.page, this.pageSize)
        .then(response => {
          this.memberAwards = response.data;
          this.loading = false;
          this.successful = true;
        },
        error => {
          this.message = (error.response && error.response.data) || error.message || error.toString();
        })
        .catch(e => {
          //console.log(e);
          this.message = 'Error: '+e.message;
        });
    },

    handlePageChange(value) {
      this.page = value;
      this.retrieveMemberAwards();
    },

    handlePageSizeChange(event) {
      this.pageSize = event.target.value;
      this.page = 1;
      this.retrieveMemberAwards();
    },

    toggleClass(el, className) {
      if (el.className.indexOf(className) >= 0) {
         el.className = el.className.replace(className,"");
      }
      else {
        el.className  += className;
      }
    },

    membersList() {
      this.$router.push('/members');
    }

  },
  mounted() {
    this.retrieveMemberAwards();
  }
};
</script>

<style>
.list {
  text-align: left;
  max-width: 100%;
  margin: auto;
  margin-top: 3.2em;
}
.paginate{
  margin-top: 1.7em;
}
.hgap{
  clear: both;
  margin-top: 1.1em;
}

.space-rgt{
  margin-right:2em;
}

.gridview
{
    border-collapse: collapse;
    margin: 0px 10px 10px 0;
    /*box-shadow: 3px 3px 4px #bbb;*/
    width: 100%;
    max-width: 100%;    
}

.gridview, .gridview td,  .gridview th
{
    border:  1px solid #cccccc;
}

.gridview th
{
    text-align: left;
    /*font-size: 1.2em;*/
    font-weight: normal;
    color: #F9F9F9;    
    background: #232324;
}

.gridview th a, .gridview th a:link, .gridview th a:visited, .gridview th a:active
{
    color: #fff;
    text-decoration: none;
}

.gridview th a:hover
{
    text-decoration: underline;
}

.gridview tr
{
    background: #fff;
}

.gridview tr:nth-child(odd) 
{
    background-color: #fff;
}
.gridview tr:nth-child(even) 
{
    background-color: #fff;
}

.gridview td 
{
    font-weight: normal;    
    text-align: left;
    vertical-align: top;
}

.gridview td, table th
{
    padding: 5px 8px;
}

.gridview tfoot td
{
    background-color: #fff;
}

.gridview tfoot td .page
{
    color: #000000;
    font-weight: bold;
}

.gridview tr.subfoot, .gridview tr.subfoot td
{
    background-color: #1E90FF;
}

.gridview tr:hover td, .gridview tbody tr:hover td
{
    background-color: #1E90FF;
    color: #fff;
}

.gridview .selected, .gridview tr td .selected
{
    background-color: #1E90FF;
    color: #fff;
}
.alignright{
  float: right;
}
  
</style>